import axios from 'axios'

export const surveyResultsUrl = '/api/rest/recording/surveyResults'

export default {
  async getSurveyResults(ccrId) {
    try {
      const response = await axios.get(surveyResultsUrl, { params: { ccrId } })
      return response.data && response.data.length > 0 ? response.data[0] : null
    } catch (error) {
      throw new Error(error)
    }
  },
}
